module.exports = __webpack_public_path__ + "img/9788949123363.5bef358a.jpg";